import script from "./MainMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=4b4c4b3e&lang=scss"

const __exports__ = script;

export default __exports__